import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Separator from '../../../core/layout/Separator';
import Button from '../../../core/form/Button';
import Card from '../../../core/layout/Card';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import MasteryTestListContainer from '../../mastery-test/components/MasteryTestListContainer';
import UnitListContainer from './unit/UnitListContainer';
import UnitListFilterContainer from './unit/UnitListFilterContainer';
import Alert from '../../../core/layout/Alert';
import DownloadContent from './DownloadContent';
import ModuleContentStatsContainer from './ModuleContentStatsContainer';
import { Roles } from '../../../core/util';
import UnitDivisionFormDialogContainer from './unit/UnitDivisionFormDialogContainer';
import AddExistingUnitFormDialogContainer from './unit/AddExistingUnitFormDialogContainer';

const ModuleDetailScene = (props) => (
  <div>
    <Breadcrumb
      fetching={props.fetching}
      crumbs={[
        {
          text: `Course - ${props.module.course.name}`,
          link: '/modules',
        },
        {
          text: `Module - ${props.module.name}`,
          link: `/modules/${props.module.id}`,
        },
      ]}
    />
    {props.module.educationGoal && (
      <div>
        <Alert title="Educational Goal" description={props.module.educationGoal} />
        <Separator />
      </div>
    )}
    {[Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role) && (
      <>
        <Card title="Reports" loading={props.fetching} collapsible={true} initialCollapse={true}>
          {props.module.id ? <ModuleContentStatsContainer moduleId={props.module.id} /> : <div />}
        </Card>
        <Separator size="md" />
      </>
    )}
    <Card
      title="Mastery test"
      loading={props.fetching}
      actions={
        [Roles.ADMIN, Roles.CONTENT_ADMIN, Roles.DISTRIBUTOR_CONTENT_ADMIN].includes(localStorage.role) && (
          <Button
            type="primary"
            icon="plus"
            onClick={() => browserHistory.push(`/modules/${props.module.id}/mastery-tests/new`)}
            label="New Mastery Test"
          />
        )
      }
    >
      {props.module.id ? <MasteryTestListContainer moduleId={props.module.id} /> : <div />}
    </Card>
    <Separator size="md" />
    <Card
      title="Units"
      loading={props.fetching}
      actions={
        <div style={{ display: 'flex', columnGap: 4 }}>
          {[Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role) && (
            <DownloadContent moduleId={props.module.id} />
          )}
          {[Roles.ADMIN, Roles.CONTENT_ADMIN, Roles.DISTRIBUTOR_CONTENT_ADMIN].includes(localStorage.role) && (
            <Button type="default" icon="plus" label="Add Existing Unit" onClick={props.onAddExistingUnitClick} />
          )}
          {[Roles.ADMIN, Roles.CONTENT_ADMIN, Roles.DISTRIBUTOR_CONTENT_ADMIN].includes(localStorage.role) && (
            <Button
              type="primary"
              icon="plus"
              onClick={() => browserHistory.push(`/modules/${props.module.id}/units/new`)}
              label="New Unit"
            />
          )}
        </div>
      }
    >
      <UnitListFilterContainer />
      {props.module.id && <UnitListContainer moduleId={props.module.id} academicPlan={props.module.academicPlan.key} />}
      <UnitDivisionFormDialogContainer />
      <AddExistingUnitFormDialogContainer />
    </Card>
  </div>
);

ModuleDetailScene.propTypes = {
  module: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    educationGoal: PropTypes.string,
    course: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  fetching: PropTypes.bool.isRequired,
  onAddExistingUnitClick: PropTypes.func.isRequired,
};

ModuleDetailScene.defaultProps = {
  module: {
    course: {},
  },
};

export default ModuleDetailScene;
